<template>
    <div class="landing-container">
        <div class="banner-top">
            <div class="container container-top">
                <h1>Buy En Primeur with Vindome</h1>
                <h3 class="top1">Secure a great return by investing in the future.</h3>
                <v-btn class="btn-start" v-on:click="() => $router.push(this.localePath({ path: '/en-primeur/'}))">Start trading now</v-btn>
            </div>
        </div>

        <div class="download-container2">
            <div class="container">
                <div class="contactus-title2">Why invest in En Primeur?</div>
                <v-row>
                    <v-col class="col-md-4 right-half-padding">
                        <div class="how-icon why1">
                            <div class="card-icon"></div>
                            <div class="card-text">Lowest Price</div>
                            <div class="card-text2">Investing in vintages at their lowest market rate provides best possible returns</div>
                        </div>
                    </v-col>
                    <v-col class="col-md-4 right-half-padding left-half-padding">
                        <div class="how-icon why2">
                            <div class="card-icon"></div>
                            <div class="card-text">More Time to Sell</div>
                            <div class="card-text2">Speculating on the futures market means you decide when it’s the right time to sell</div>
                        </div>
                    </v-col>
                    <v-col class="col-md-4 left-half-padding">
                        <div class="how-icon why3">
                            <div class="card-icon"></div>
                            <div class="card-text">Higher Profit</div>
                            <div class="card-text2">Long investment horizons means En Primeur offers the best potential ROI possible</div>
                        </div>
                    </v-col>
                </v-row>
            </div>
        </div>

        <div class="container">
            <div class="contactus-title2 contactus-title2-better">How Does Vindome Enhance En Primeur Investment?</div>
            <v-row>
                <v-col class="col-md-4 right-half-padding">
                    <div class="how-icon why4">
                        <div class="card-icon"></div>
                        <div class="card-text">Online 24/7<br/>Market</div>
                        <div class="card-text2">Easily accessible Live Market for a hassle free investment experience</div>
                    </div>
                </v-col>
                <v-col class="col-md-4 right-half-padding left-half-padding">
                    <div class="how-icon why5">
                        <div class="card-icon"></div>
                        <div class="card-text">Safe & Secure<br>Transactions</div>
                        <div class="card-text2">With little correlation to the Stock Market, en primeur has low levels of risk and shown stable returns.</div>
                    </div>
                </v-col>
                <v-col class="col-md-4 left-half-padding">
                    <div class="how-icon why6">
                        <div class="card-icon"></div>
                        <div class="card-text">Personalised<br>offers</div>
                        <div class="card-text2">Vindome can create bespoke offers to suit your budget and investment horizon</div>
                    </div>
                </v-col>
            </v-row>
        </div>

        <div class="download-container2 download-container222">
            <div class="container">
                <div class="contactus-title2 contactus-title2-better">{{ $t('landing19') }}</div>

                <div class="howto-img-wrapper">
                    <div class="how-bullet-item">
                        <div class="how-bullet-item1"></div>
                        <div class="howto-title">{{ $t('landing20') }}</div>
                        <div class="vindome-bullet-subtitle">{{ $t('landing21') }}</div>
                    </div>
                    <div class="how-bullet-item">
                        <div class="how-bullet-item2"></div>
                        <div class="howto-title">{{ $t('landing22') }}</div>
                        <div class="vindome-bullet-subtitle">{{ $t('landing23') }}</div>
                    </div>
                    <div class="how-bullet-item">
                        <div class="how-bullet-item3"></div>
                        <div class="howto-title">{{ $t('landing24') }}</div>
                        <div class="vindome-bullet-subtitle">{{ $t('landing25') }}</div>
                    </div>
                </div>
            </div>
        </div>

        <div class="container">
            <div class="contactus-title2 contactus-title2-better">Vindome’s Online En Primeur Market</div>
            <WineMarketHome :enPrimeur="true"></WineMarketHome>

            <div class="contactus-title2 contactus-title2-better">{{ $t('contact-en-wines') }}</div>

            <div class="contact-wrapper2">
                <div class="contact-text">{{ $t('contact-en-wines2') }}</div>
                <div class="show-contact-btn" v-on:click="showContactUsEn=true">{{ $t('contact0') }}</div>
            </div>
        </div>

        <div class="container">
            <div class="phone-wrapper">
                <div class="phone-img"></div>
                <div class="phone-text-wrapper">
                    <h3 class="top1">{{ $t('landing3') }}</h3>
                    <div class="download-btn-wrapper">
                        <a href="https://apps.apple.com/us/app/vindome/id1494570524" target="_blank" class="home-download-ios"></a>
                        <a href="https://play.google.com/store/apps/details?id=com.vindome.wine&hl=en_US&gl=US" target="_blank" class="home-download-android"></a>
                    </div>
                </div>
            </div>
        </div>

        <v-dialog v-model="showStore" persistent max-width="376px">
            <v-card class="qr-popup">
                <div class="qr-close" v-on:click="hideQR"></div>
                <div class="qr-title">Download the app</div>
                <div :class="{'qr-image': true, 'appStore': appStore, 'googlePlay': googlePlay}"></div>
                <div class="stores">
                    <a v-on:click="() => { storeClick(true) }" href="https://apps.apple.com/app/vindome-wine/id1494570524" target="_blank" class="appstore" v-if="appStore"></a>
                    <a v-on:click="() => { storeClick(false) }" href="https://play.google.com/store/apps/details?id=com.vindome.wine" target="_blank" class="gplay" v-if="googlePlay"></a>
                </div>
            </v-card>
        </v-dialog>

        <v-dialog content-class="contactus-dialog" v-model="showContactUsEn" persistent max-width="570px">
            <v-card class="contact-card">
                <v-card-title>
                    <div class="contactus-headline">Contact us to order En Primeur</div>
                    <div class="contactus-close" @click="showContactUsEn = false">&times;</div>
                </v-card-title>
                <div class="contact-wrapper" v-if="!successMessageEn">
                    <v-flex>
                        <span class="login-label">{{ $t('contact1') }}</span>
                        <v-text-field
                                v-model="userName"
                                class="email-input"
                                :rules="[rules.required]"
                        ></v-text-field>
                    </v-flex>

                    <v-flex>
                        <span class="login-label">{{ $t('contact2') }}</span>
                        <v-text-field
                                v-model="userEmail"
                                class="email-input"
                                :rules="[rules.required, rules.emailValid]"
                        ></v-text-field>
                    </v-flex>

                    <v-flex>
                        <span class="login-label">{{ $t('contact3') }}</span>
                        <v-textarea
                                class="contact-textarea"
                                :rules="[rules.required]"
                                v-model="notes"
                                rows="3"
                        ></v-textarea>
                    </v-flex>

                    <v-btn class="submit-btn" text v-on:click="sendContact">{{ $t('contact4') }}</v-btn>
                </div>
                <div class="contact-wrapper success-wrapper" v-else>
                    <div class="success-info">{{ $t('contact6') }}</div>
                    <v-btn class="done-btn" text v-on:click="resetForm">{{ $t('contact7') }}</v-btn>
                </div>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    import { required, email } from 'vuelidate/lib/validators';
    import WineMarketHome from "../../components/WineMarketHome";
    import {AMarket} from "@/store/actions";
    import axios from "axios";

    export default {
        name: "LpEnPrimeur",
        head: {
            title: 'En Primeur | Fine Wine Trading App',
            meta: [
                {
                    hid: 'description',
                    name: 'description',
                    content: 'Buy and sell fine wines from your smartphone today! Vindome is the fast, secure and easy way to become a wine trader – right from your smartphone.'
                }
            ],
            bodyAttrs: {
                class: 'page-landing trading-desk'
            }
        },
        validations: {
            userEmail: {
                required,
                email
            },
            userName: {
                required
            }
        },
        components: { WineMarketHome },
        data () {
            return {
                showStore: false,
                showContactUsEn: false,
                appStore: false,
                googlePlay: false,
                successMessageEn: false,
                userEmail: '',
                userName: '',
                notes: '',
                errorMsg: '',
                reg: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
                rules: {
                    required: value => !!value || 'Required.',
                    min: value => value.length >= 8 || 'Min 8 characters',
                    emailValid: value => this.reg.test(value) || 'Invalid email'
                }
            }
        },
        methods: {
            storeClick(isAppStore) {
                this.$gtm.push({ event: isAppStore ? "AppStoreClick" : "GooglePlayClick" });
            },
            showQR(isAppStore) {
                this.showStore = true;
                this.appStore = isAppStore;
                this.googlePlay = !isAppStore;
            },
            hideQR() {
                this.showStore = false;
                this.appStore = false;
                this.googlePlay = false;
            },
            showPrivacy: function(article){
                if (article === 'dagospia') {
                    window.open('https://m.dagospia.com/ma-quale-bitcoin-il-vero-investimento-sicuro-e-il-vinoarriva-vindome-l-app-per-fare-254689');
                } else if (article === 'jamesmagazine') {
                    window.open('https://www.jamesmagazine.it/news/vindome-lapp-investe-sui-vini-pregiati/');
                } else if (article === 'vice') {
                    window.open('https://www.vice.com/it/article/k7anww/guadagnare-con-il-vino');
                } else {
                    window.open(`https://vindome.net/Vindome_${article}.pdf`);
                }
            },
            async sendContact () {
                let contactCtrl = this;
                let options = {
                    method: 'POST',
                    url: 'https://forms.raketa.cloud/submit/XXj4SzpmtB',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json;charset=UTF-8'
                    },
                    data: {
                        data: {
                            name: this.userName,
                            email: this.userEmail,
                            message: this.notes
                        }
                    }
                };
                let response = await axios(options);
                let responseOK = response && response.status === 200 && response.statusText === 'OK';
                if (responseOK) {
                    contactCtrl.successMessageEn = true
                }
            },
            resetForm () {
                this.userName = '';
                this.userEmail = '';
                this.notes = '';
                this.successMessageEn = false;
                this.showContactUsEn = false
            }
        },
        created() {
            this.$store.dispatch(AMarket.GET_HOME_WINES)
        }
    }
</script>

<style scoped>
    .submit-btn {
        background: #E1C376 !important;
        color: #FFF !important;
        width: 200px;
        height: 40px !important;
        font-size: 18px;
        border-radius: 5px;
        text-transform: none;
        font-family: 'Montserrat', Arial, Helvetica, sans-serif;
        letter-spacing: 0;
        font-weight: lighter;
        -webkit-box-shadow: none;
        box-shadow: none;
        margin: 15px auto 0;
        display: block;
    }
    .contact-wrapper {
        background: #F6F6F6;
        border-radius: 8px;
        padding: 27px 56px 32px 32px;
        margin: 32px auto 64px;
        width: 440px;
    }
    .contactus-close {
        position: absolute;
        top: 15px;
        right: 15px;
    }
    .contactus-headline {
        font-family: Montserrat, sans-serif;
        font-style: normal;
        font-weight: bold;
        font-size: 25px;
        line-height: 120%;
        text-align: center;
        color: #303030;
        width: 300px;
        margin: 0 auto;
    }
    .contact-wrapper2 {
        background: #F6F6F6;
        border-radius: 8px;
        padding: 27px 38px 32px 32px;
        margin: 54px auto;
        max-width: 440px;
        text-align: center;
    }
    .contact-text {
        font-family: Roboto, sans-serif;
        font-style: normal;
        font-weight: 300;
        font-size: 16px;
        line-height: 160%;
        color: #000000;
    }
    .show-contact-btn {
        background: #CEA94B;
        padding: 0 16px;
        min-width: 120px;
        height: 32px;
        line-height: 33px;
        border-radius: 4px;
        font-family: Roboto, sans-serif;
        font-weight: bold;
        font-size: 16px;
        color: #ffffff;
        margin: 32px auto 0;
        text-align: center;
        display: inline-block;
    }
    .show-contact-btn:hover,
    .submit-btn:hover,
    .contactus-close:hover {
        cursor: pointer;
    }
    .success-wrapper {
        text-align: center;
        background: url('../../assets/success_icon.png') no-repeat center 30px;
        padding: 140px 32px 0;
    }
    .success-info {
        color: #303030;
    }
    .done-btn {
        background: #E1C376 !important;
        color: #FFF !important;
        margin-top: 30px;
        width: 200px;
        height: 40px !important;
        font-size: 18px;
        border-radius: 5px;
        text-transform: none;
    }
    h1 {
        font-family: Montserrat, sans-serif;
        font-style: normal;
        font-weight: bold;
        font-size: 48.83px;
        line-height: 100%;
        text-align: center;
        color: #303030;
        margin-top: 56px;
        margin-bottom: 32px;
    }
    h3 {
        font-family: Montserrat, sans-serif;
        font-style: normal;
        font-weight: normal;
        font-size: 25px;
        line-height: 120%;
        text-align: center;
        color: #303030;
    }
    h3.top1 {
        max-width: 480px;
        margin: 0 auto;
    }
    .container-top h3.top1 {
        font-family: Montserrat, sans-serif;
        font-style: normal;
        font-weight: normal;
        font-size: 25px;
        line-height: 120%;
        text-align: center;
        color: #FFFFFF;
    }
    .landing-container {
        background: #ffffff;
        padding-top: 24px;
    }
    .banner-top {
        background: url('../../assets/landing/lp1.png') no-repeat center;
        background-size: cover;
        width: 100%;
        height: 454px;
    }
    .container {
        max-width: 1170px;
        padding: 0;
        font-family: 'Montserrat', Arial, Helvetica, sans-serif;
    }
    .container-top {
        height: 500px;
    }
    .container-top h1 {
        font-family: Montserrat;
        font-style: normal;
        font-weight: bold;
        font-size: 48.83px;
        line-height: 100%;
        text-align: center;
        color: #FFFFFF;
        padding-top: 123px;
    }
    .btn-start {
        background-color: #CEA94B !important;
        border-radius: 4px;
        display: block;
        order: 0;
        margin: 32px auto 0;
        text-transform: capitalize;
        font-family: Roboto, sans-serif;
        font-style: normal;
        font-weight: bold;
        font-size: 16px;
        line-height: 150%;
        text-align: center;
        color: #FFFFFF;
    }
    .vlogo {
        background: url('../../assets/landing/vlogo.png') no-repeat center;
        width: 118px;
        height: 118px;
        margin: 0 auto;
        position: relative;
        z-index: 2;
    }
    .download-container {
        background: #F6F6F6;
        padding: 86px 0 51px;
        position: relative;
        top: -56px;
    }
    .download-container2 {
        background: #F6F6F6;
        padding: 62px 0 51px;
    }
    .download-container222 {
        margin-top: 54px;
        padding-top: 5px;
    }
    .download-container3 {
        background: #F6F6F6;
        height: 325px;
    }
    .phone-wrapper {
        max-width: 866px;
        margin: 0 auto;
        overflow: hidden;
    }
    .phone-img {
        width: 208px;
        height: 414px;
        margin-top: 19px;
        margin-right: 82px;
        margin-bottom: 60px;
        display: inline-block;
        background: url('../../assets/landing/lp10.png') no-repeat center;
    }
    .phone-text-wrapper {
        display: inline-block;
        vertical-align: top;
        margin-top: 108px;
    }
    .phone-text-wrapper h3.top1 {
        text-align: left;
        font-size: 33px;
    }
    .login-label {
        position: absolute;
        font-size: var(--fs-base);
        color: #303030;
        font-weight: 300;
    }
    .phone-text-wrapper .download-btn-wrapper {
        margin: 40px auto 0;
        text-align: left;
    }
    .qr-popup.v-card {
        border-radius: 24px;
        height: 421px;
    }
    .qr-image {
        width: 320px;
        height: 300px;
        margin: 0 auto;
    }
    .qr-image.appStore {
        background: #ffffff url('../../assets/appstore-qr.svg') no-repeat center;
        background-size: 280px;
    }
    .qr-image.googlePlay {
        background: #ffffff url('../../assets/gplay-qr.svg') no-repeat center;
        background-size: 280px;
    }
    .qr-title {
        text-align: center;
        font-size: 22.5px;
        line-height: 31.5px;
        color: #090D0E;
        padding-top: 20px;
    }
    .qr-close {
        position: absolute;
        z-index: 1;
        top: 16px;
        right: 16px;
        width: 40px;
        height: 40px;
        border-radius: 55%;
        background: #E6C67C url('../../assets/icon-close.svg') no-repeat center;
    }
    .qr-close:hover {
        background-color: #F1E2C4;
        cursor: pointer;
    }
    .qr-popup .stores {
        margin: 0;
    }
    .qr-popup .appstore, .qr-popup .gplay {
        width: 118px;
        height: 38px;
        margin: 0 auto;
        display: block;
    }
    .home-download-android,
    .home-download-ios {
        display: inline-block;
        width: 163px;
        height: 48px;
    }
    .home-download-ios {
        background: url('../../assets/app/appstore.png') no-repeat center;
        width: 144px;
        margin-right: 16px;
    }
    .home-download-android {
        background: url('../../assets/app/gplay.png') no-repeat center;
    }
    .home-download-android:hover,
    .home-download-ios:hover {
        cursor: pointer;
    }
    .download-btn-wrapper {
        margin: 50px auto 0;
        text-align: center;
    }
    .contactus-title2 {
        font-family: Montserrat, sans-serif;
        font-style: normal;
        font-weight: normal;
        font-size: 39.06px;
        line-height: 120%;
        text-align: center;
        color: #303030;
        margin-bottom: 60px;
    }
    .contactus-title2-better {
        max-width: 769px;
        margin: 57px auto 62px;
    }
    .article-text:hover {
        cursor: pointer;
    }
    .testimonial-logo {
        width: 161px;
        height: 89px;
        margin: 0 auto 19px;
    }
    .logo-decanter {
        background: url('../../assets/app/decanter.png') no-repeat center;
    }
    .logo-winespectator {
        background: url('../../assets/app/winespectator.png') no-repeat center;
    }
    .logo-saveur {
        background: url('../../assets/app/saveur.png') no-repeat center;
    }

    .logo-larepubblica {
        background: url('../../assets/app/larepubblica.png') no-repeat center;
        background-size: contain;
    }
    .logo-ilgiornale {
        background: url('../../assets/app/ilgiornale.png') no-repeat center;
        background-size: contain;
    }
    .logo-businessinsider {
        background: url('../../assets/landing/lp3.png') no-repeat center;
        background-size: contain;
    }
    .logo-cosmopolitan {
        background: url('../../assets/app/cosmopolitan.png') no-repeat center;
        background-size: contain;
    }
    .logo-digitalclub {
        background: url('../../assets/app/digitalclub.png') no-repeat center;
        background-size: contain;
    }
    .logo-mixerplanet {
        background: url('../../assets/app/mixerplanet.png') no-repeat center;
        background-size: contain;
    }
    .logo-igrandivini {
        background: url('../../assets/app/igrandivini.png') no-repeat center;
        background-size: contain;
    }
    .logo-vanityfair {
        background: url('../../assets/app/vanityfair.svg') no-repeat center;
        background-size: contain;
    }
    .logo-winenews {
        background: url('../../assets/app/winenews.png') no-repeat center;
        background-size: contain;
    }
    .logo-dagospia {
        background: url('../../assets/landing/lp2.png') no-repeat center;
        background-size: contain;
    }
    .logo-vice {
        background: url('../../assets/landing/lp4.png') no-repeat center;
        background-size: contain;
    }
    .logo-jamesmagazine {
        background: url('../../assets/app/jamesmagazine.png') no-repeat center;
        background-size: contain;
    }
    .testimonial-info {
        font-weight: 400;
        font-size: 25px;
        line-height: 120%;
        text-align: center;
        color: #303030;
    }
    .mobileapp-container {
        max-width: 1366px;
        margin: 0 auto;
    }
    .right-half-padding {
        padding-right: 25px
    }
    .left-half-padding {
        padding-left: 25px
    }
    .card-icon {
        height: 96px;
        width: 100%;
        margin-bottom: 40px;
    }
    .why1 .card-icon {
        background: url('../../assets/landing/lp5.png') no-repeat center center;
        background-size: contain;
    }
    .why2 .card-icon {
        background: url('../../assets/landing/lp6.png') no-repeat center center;
        background-size: contain;
    }
    .why3 .card-icon {
        background: url('../../assets/landing/lp7.png') no-repeat center center;
        background-size: contain;
    }
    .why4 .card-icon {
        background: url('../../assets/landing/dots.png') no-repeat center center;
        background-size: contain;
    }
    .why5 .card-icon {
        background: url('../../assets/landing/lp8.png') no-repeat center center;
        background-size: contain;
    }
    .why6 .card-icon {
        background: url('../../assets/landing/lp9.png') no-repeat center center;
        background-size: contain;
    }
    .card-text {
        font-family: Montserrat, sans-serif;
        font-style: normal;
        font-weight: normal;
        font-size: 32.83px;
        line-height: 120%;
        text-align: center;
        color: #303030;
        margin-bottom: 16px;
    }
    .card-text2 {
        font-family: Roboto, sans-serif;
        font-style: normal;
        font-weight: 300;
        font-size: 16px;
        line-height: 160%;
        text-align: center;
        color: #303030;
        max-width: 292px;
        margin: 0 auto;
    }
    .howto-img-wrapper {
        margin-bottom: 100px;
    }
    .how-bullet-item {
        display: inline-block;
        width: calc(33.33% - 29px);
        vertical-align: top;
        position: relative;
    }
    .how-bullet-item:nth-child(1),
    .how-bullet-item:nth-child(2) {
        margin-right: 39px;
    }
    .how-bullet-item1 {
        background: url('../../assets/landing/storage2.png') no-repeat center;
        height: 220px;
        width: 100%;
        margin-bottom: 35px;
        background-size: cover;
    }
    .how-bullet-item2 {
        background: url('../../assets/landing/storage1.png') no-repeat center;
        height: 220px;
        width: 100%;
        margin-bottom: 35px;
        background-size: cover;
    }
    .how-bullet-item3 {
        background: url('../../assets/landing/storage.png') no-repeat center;
        height: 220px;
        width: 100%;
        margin-bottom: 35px;
        background-size: cover;
    }
    .how-bullet-item .howto-title {
        font-family: Montserrat, sans-serif;
        font-style: normal;
        font-weight: bold;
        font-size: 25px;
        line-height: 120%;
        color: #303030;
        text-transform: none;
        margin-bottom: 32px;
    }
    .vindome-bullet-subtitle {
        font-family: Roboto, sans-serif;
        font-style: normal;
        font-weight: 300;
        font-size: 16px;
        line-height: 160%;
        color: #000000;
    }
    .faq-item {
        max-width: 784px;
        margin: 0 auto;
        padding: 31px 0;
    }
    .faq-item-last {
        margin-bottom: 52px;
    }
    .faq-item-header {
        font-family: Montserrat, sans-serif;
        font-style: normal;
        font-weight: bold;
        font-size: 25px;
        line-height: 120%;
        color: #303030;
        margin-bottom: 16px;
    }
    .faq-item-text {
        font-family: Roboto, sans-serif;
        font-style: normal;
        font-weight: 300;
        font-size: 16px;
        line-height: 160%;
        color: #404040;
        white-space: pre-wrap;
    }

    @media (max-width: 767px) {
        h1 {
            font-size: 28px;
        }
        h3 {
            font-size: 20px;
        }
        .container-top h1 {
            padding-top: 80px;
            margin-top: 21px;
        }
        .container {
            padding: 0 12px;
        }
        .container-top {
            background-size: contain;
            height: 420px;
        }
        .card-icon {
            margin-bottom: 10px;
        }
        .download-container2 .row {
            display: block;
        }
        .download-container2 .col {
            width: 100%;
            padding: 0;
            margin: 0 0 60px 0;
        }
        .contactus-title2 {
            font-size: 28px;
            line-height: 30px;
        }
        .testimonial-info {
            padding: 0 15px;
        }
        .howto-img-wrapper {
            padding: 0 15px;
            margin-bottom: 50px;
        }
        .how-bullet-item {
            width: 100%;
            margin-bottom: 30px;
        }
        .how-bullet-item:nth-child(1),
        .how-bullet-item:nth-child(2) {
            margin-right: 0;
        }
        .how-bullet-item .howto-title {
            margin-bottom: 0;
        }
        .vindome-bullet-subtitle {
            margin-bottom: 20px;
        }
        .how-bullet-item1 {
            margin-bottom: 15px;
        }
        .download-container3 {
            height: 500px;
        }
        .phone-img {
            display: block;
            margin: 19px auto 0;
        }
        .phone-text-wrapper {
            margin-top: 22px;
        }
        .phone-text-wrapper h3.top1 {
            text-align: center;
        }
        .phone-text-wrapper .download-btn-wrapper {
            margin: 30px auto 0;
            text-align: center;
        }
        .contactus-title2-better {
            margin: 30px auto;
        }
        .faq-item-header {
            font-size: 20px;
        }
    }
</style>
<style>
    @media (max-width: 767px) {
        .page-landing .v-application .hidden-md-and-up {
            display: none !important;
        }
        .page-landing .logo img {
            margin: 0 auto !important;
        }
    }
    .page-landing .logo img {
        margin-top: 17px;
    }
    .page-landing .lang-nav:hover .submenu {
        right: 0;
    }
    .page-landing .theme--light.v-application {
        background: #ffffff;
    }
    .page-landing .header-toolbar {
        box-shadow: none;
    }
    .page-landing .site-navigation,
    .page-landing .notifications-wrapper,
    .page-landing .site-navigation-my-account,
    .page-landing .header-login-btn {
        display: none;
    }
    .page-landing .locale-changer .site-navigation {
        display: block;
    }
    .page-landing .locale-changer {
        position: absolute;
        right: 30px;
        top: 25px;
    }
    .contactus-dialog {
        background: #ffffff;
    }
    .theme--light.v-card.contact-card {
        box-shadow: none;
        padding-top: 31px;
        transition: none;
        background: #fff;
    }
    .contact-wrapper .flex {
        margin-top: 20px;
        text-align: left;
    }
    .contact-wrapper .v-input input {
        height: 40px;
        max-height: unset;
        margin-top: 20px;
        padding-left: 15px;
    }
</style>
